function getParameterByName (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

let select = document.getElementById('etablissement-select');
let etablissements = JSON.parse(window.etablissements);
let etablissementConcerne = getParameterByName('etab');

// disable the select option placeholder
select.options[0].setAttribute('disabled', true);
select.options[0].value = '';

// add all etablissements to select options
for (let i = 0; i < etablissements.length; i++) {
    select.options[select.options.length] = new Option(etablissements[i].text, etablissements[i].value);
    if (select.options[i].value === etablissementConcerne) {
        select.options[i].setAttribute('selected', true);
    }
}




// WEBPACK FOOTER //
// ./resources/assets/js/includes/contact.js